import { http } from '../../../../api/http';
import type { PrecioProveedor, SaveBulkRequest } from '../types';

export class PrecioProveedorService {
  private static readonly BASE_URL = '/produccion/precioproveedor';

  static async getByProveedor(idProveedor: number): Promise<PrecioProveedor[]> {
    try {
      const response = await http.get(`${this.BASE_URL}/proveedor/${idProveedor}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching precios del proveedor:', error);
      throw error;
    }
  }

  static async getByProveedorAndTipo(
    idProveedor: number,
    tipoProceso: string,
    tipoOperacion: string
  ): Promise<PrecioProveedor[]> {
    try {
      const response = await http.get(
        `${this.BASE_URL}/proveedor/${idProveedor}/${tipoProceso}/${tipoOperacion}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching precios filtrados:', error);
      throw error;
    }
  }

  static async save(precio: PrecioProveedor): Promise<PrecioProveedor> {
    try {
      const response = await http.post(`${this.BASE_URL}`, precio);
      return response.data;
    } catch (error) {
      console.error('Error guardando precio:', error);
      throw error;
    }
  }

  static async saveBulk(request: SaveBulkRequest): Promise<{ success: boolean }> {
    try {
      const response = await http.post(`${this.BASE_URL}/bulk`, request);
      return response.data;
    } catch (error) {
      console.error('Error guardando precios en bulk:', error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error eliminando precio ${id}:`, error);
      throw error;
    }
  }
}
